import React from 'react';

const items = [
  { value: '500+', label: 'Students Trained in Bhopal' },
  { value: '5+', label: 'Years Experience' },
  { value: 'NISM', label: 'Certified Founder' },
  { value: '4.9★', label: 'Google Rating' },
  { value: 'MP Nagar', label: 'Bhopal Location' },
];

const StatsStrip = () => {
  return (
    <div className="bg-white border-y border-gray-200 py-6" data-testid="stats-strip">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-center justify-center gap-x-8 sm:gap-x-12 gap-y-4">
          {items.map((it, i) => (
            <React.Fragment key={it.label}>
              <div className="text-center min-w-[110px]">
                <div className="text-2xl sm:text-3xl font-extrabold text-green-600 leading-none">{it.value}</div>
                <div className="text-xs sm:text-sm text-gray-600 font-medium mt-1">{it.label}</div>
              </div>
              {i < items.length - 1 && (
                <div className="hidden sm:block w-px h-10 bg-gray-200" />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StatsStrip;
